// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"369":"4f5f2076","429":"7a4084bb","518":"896a3ced","529":"4126bcf7","851":"e61a0dc5","952":"95f4b073"}[chunkId] + ".chunk.css";
};